<template>
  <div v-if="user.id">
    <Index />
  </div>
</template>

<script>
import Index from '@/components/hr/index.vue'

import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    Index
  },
  created () {
  },
  watch: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  data: function() {
    return { }
  },
}
</script>

